import React, {Component} from 'react';
import styled from 'styled-components';

import SectParagrap from '../SectParagraph/SectParagraph';
import InfoWrapper from '../InfoWrapper/InfoWrapper';
const Wrapper = styled.section`

`;

class SectionWrapper extends Component {
    constructor(props) {
        super(props) 
}
    componentDidMount() {
        const scroll = function() {
            // const center = bcground.c
            const bcground = document.querySelector('.infoWrapper');
            const actualY = Number.parseFloat(window.scrollY).toFixed();
            const elDistanceToTop = window.pageYOffset + bcground.getBoundingClientRect().top;
            const bcgroundTop = Number.parseFloat(elDistanceToTop).toFixed();
            bcground.style.backgroundPosition = `50% ${((bcgroundTop-actualY)/7)}px`;          
    }
        document.addEventListener('scroll', scroll);
        } 
       

    render() {
    return (
        <Wrapper>
            <SectParagrap title={this.props.title} text={this.props.text}/>
            <InfoWrapper content={this.props.content} fourItems={this.props.fourItems} className="infoWrapper" resize={this.props.resize}/>
        </Wrapper>
    )
}
};

export default SectionWrapper